

import React, { useState , useEffect} from "react";
import { Link } from "react-router-dom";
import styles from './forgotPasswordForm.module.css';
import { FcGoogle } from "react-icons/fc";
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../../global_state_components/AuthProvider';

import { useGoogleLogin } from '@react-oauth/google';
import { axiosInstance } from "../../../lib/axiosInstance";
//import toast from 'react-hot-toast';
import { useGlobalState } from "../../global_state_components/GlobalStateProvider";



function ForgotPasswordForm() {
  const navigate = useNavigate();    //Use the useNavigate hook to programmatically navigate to another route in response to an event (like a button click).

  const { isAuthenticated, setIsAuthenticated} = useAuth();    //Defined in AuthProvider.jsx

  const [email, setEmail] = useState({
    email: ""
  });

  const [errorMessage, setErrorMessage] = useState("");

  const [isEmailSent, setIsEmailSent] = useState(false);

  function handleChange(event) {
    //console.log(event.target); //When printed it will print the html tag which triggered the event.
    //In React, event.target is a synthetic representation of the actual DOM element and is wrapped in a synthetic event object.
    //Although it appears as an HTML-like string when printed, it is still an object with various properties and methods.
    //When you destructure const { value, name } = event.target;, it extracts the value and name properties from that synthetic event target object, enabling you to conveniently access the values of the corresponding input element's value and name attributes.
    //I think when the console.log statement is used to print the "event.target" object, react detects it and displays it as the html element which triggered the event using the synthetic event wrapper object.

    const { value, name } = event.target;
    //console.log(value, name);

    //Using spread operator made it short.
    setEmail({
      email: value
    });
  }

  async function handleFormSubmit(event) {
    event.preventDefault();

    try {
      setErrorMessage(""); // Clear any previous errors
      // Make a POST request to your server
      const response = await axiosInstance.post('/auth/forgot-password', email); 
      
      //setIsAuthenticated('authenticated');
      
      //toast.success("A reset link has been sent to your email.", {duration: 10000});

      //console.log("/auth/forgot-password response.data : ",response.data);

      setIsEmailSent(true);
      //navigate('/signin');    //Navigate to MyProfile page.
      // if (isAuthenticated==='authenticated'){
      //   navigate('/matrix');      //--------- Redirect to the protected route. Before entering the private route authorisation is checked by the PrivateRoute component.
      // }else {
      //   navigate('/my_profile');      //--------- Redirect to the protected route. Before entering the private route authorisation is checked by the PrivateRoute component.
      // }

    } catch (error) {
      setErrorMessage(
                        (Array.isArray(error.response?.data?.message)? error.response?.data?.message[0] : error.response?.data?.message) 
                        || 
                        "An error occurred!"
                      );


      //------------------
      if (error.response) {
        // Server responded with a status other than 200 range
        console.log("Error Data: ", error.response.data);
        console.log("Error Status: ", error.response.status);
        console.log("Error Headers: ", error.response.headers);
      } else if (error.request) {
        // Request was made but no response was received
        console.log("Error Request: ", error.request);
      } else {
        // Something else happened
        console.log("Error Message: ", error.message);
      }
    }
  };



  return(
    (isEmailSent === false)?(    
                              <div className={styles.inner_container}>
                                <h1 className={styles.welcome_title}>
                                  Reset your password
                                </h1>
                                <p style={{textAlign: "center"}}>
                                  We'll send you a password reset link to the email address that you use for your Discusslearn account.
                                </p>
                                <form onSubmit={handleFormSubmit}>
                                  <input
                                    onChange={handleChange}
                                    value={email.email}
                                    name="email"
                                    placeholder="email"
                                    type="email"
                                    className={styles.input}
                                    required
                                  />
                                  {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
                                  <button className={styles.signup_button} type="submit">Send reset link</button>
                                </form>
                                        
                                <div>
                                  <p className={styles.already_account_p_tag}>Don't have an account?</p>
                                  <Link className={styles.link} to="/signup"><span>Sign up</span></Link>
                                </div>
                              </div>
                            ):(
                              <div className={styles.inner_container}>
                                <h1 className={styles.welcome_title}>
                                  Reset link sent
                                </h1>
                                <p>
                                  A password reset link has been sent to your mail.
                                </p> 
                                <form>
                                  <button className={styles.signup_button} onClick={() => navigate("/signin")}>Go back to Login</button>
                                </form>
                                        
                                <div className={styles.already_account_div}>
                                  <p className={styles.already_account_p_tag}>Don't have an account?</p>
                                  <Link className={styles.link} to="/signup"><span>Sign up</span></Link>
                                </div>
                              </div>
                            )
  );
}

export default ForgotPasswordForm;












